module.exports = __webpack_public_path__ + "static/media/19import-45.35431387.xlsx";